export const fistFormRules = {
  createBy: [{ required: true, message: '必填字段', trigger: 'blur' }],
  belongToLevel1Name: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageVariety: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageCompanyObj: [{ required: true, message: '必填字段' }],
  storageCompanyCode: [{ required: true, message: '必填字段' }],
  storageName: [{ required: true, message: '必填字段' }],
  isSpecial: [{ required: true, message: '必填字段', trigger: 'blur' }],
  isReality: [{ required: true, message: '必填字段', trigger: 'blur' }],
};
